var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04354 2.66854C-0.514513 6.22659 -0.514513 11.9956 3.04354 15.5524C6.60159 19.1093 12.3706 19.1105 15.9274 15.5524C19.4855 11.9944 19.4855 6.22537 15.9274 2.66854C12.3694 -0.889513 6.60037 -0.889513 3.04354 2.66854ZM14.3253 9.6797H9.46902C9.46047 9.6797 9.45315 9.68458 9.44461 9.68458C9.28281 9.68458 9.12763 9.62031 9.01321 9.50589C8.8988 9.39148 8.83452 9.2363 8.83452 9.07449V2.9687C8.83452 2.8069 8.8988 2.65172 9.01321 2.5373C9.12763 2.42289 9.28281 2.35861 9.44461 2.35861C9.60642 2.35861 9.7616 2.42289 9.87601 2.5373C9.99043 2.65172 10.0547 2.8069 10.0547 2.9687V8.45952H14.3253C14.4871 8.45952 14.6423 8.5238 14.7567 8.63821C14.8712 8.75263 14.9354 8.9078 14.9354 9.06961C14.9354 9.23142 14.8712 9.3866 14.7567 9.50101C14.6423 9.61543 14.4871 9.6797 14.3253 9.6797Z",
    fill: "url(#paint0_linear_3095_262)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3095_262",
    x1: 9.48549,
    y1: 0,
    x2: 9.48549,
    y2: 18.2205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4944"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTime);
export default __webpack_public_path__ + "static/media/location-time.cb8db3b6c3ce65170658cb39456dc3a9.svg";
export { ForwardRef as ReactComponent };